var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "skin-tools", class: { "is-open": _vm.isOpen } },
    [
      _c(
        "a",
        {
          staticClass: "skin-tools-action",
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [_c("i", { staticClass: "icon-fa icon-fa-cog" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "skin-tools-content" }, [
        _c("h5", { staticClass: "mt-2" }, [_vm._v("Select Skin")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "skins" },
          _vm._l(_vm.skins, function(skin) {
            return _c("div", { key: skin.slug, staticClass: "skin-item" }, [
              _c(
                "a",
                {
                  staticClass: "skin-radio",
                  class: { active: skin.slug === _vm.selectedSkin },
                  attrs: { title: skin.title, href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.selectSkin(skin)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: { src: skin.img }
                  })
                ]
              )
            ])
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c03ee6f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c03ee6f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeSwitcher.vue
// module id = 1085
// module chunks = 0